<app-base-modal
  [title]="designBlockData().title"
  [showStateToggle]="true"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div
    class="header-modal"
    app-db-header-modal
    [designBlockData]="designBlockData()"
    [columnKey]="modalKey()"
    [isActiveUploadFile]="isActiveUploadFile"
    (uploadFiles)="uploadFiles($event)"
  ></div>
  @if (!isShowFileLibrary()) {
    <app-carousel
      [itemsCount]="dbFilesStateService.dbFilesState().length"
      [gap]="20"
      [visibleItems]="3"
      (currentIndexChange)="onIndexChange($event)"
    >
      <div class="cards">
        @for (file of dbFilesStateService.dbFilesState(); track $index) {
          <div
            class="card"
            app-db-file-card
            [file]="file"
            [designBlockEntityFileType]="designBlockEntityFileType()"
            [isEditModeActive]="isEditModeActive"
            (updateField)="updateField($event)"
          ></div>
        }
        @if (dbFilesStateService.dbFilesState().length < 3) {
          <app-file-upload-card
            class="card-upload"
            [fileUploadParams]="{
              recordId: designBlockData().id,
              parentId: designBlockData().id,
              type: designBlockEntityFileType(),
              entityFileType: designBlockEntityFileType()
            }"
            [isEditModeActive]="isEditModeActive"
            (attachFile)="attachFile($event)"
          />
        }
      </div>
    </app-carousel>
  } @else {
    <div
      class="file-library"
      app-db-file-library
      [designBlockEntityFileType]="designBlockEntityFileType()"
      [isEditModeActive]="isEditModeActive"
    ></div>
  }
  <div
    class="bottom-modal"
    app-db-bottom-modal
    [designBlockData]="designBlockData()"
    [isEditModeActive]="isEditModeActive"
    [isActiveUploadFile]="isActiveUploadFile"
    [designBlockEntityFileType]="designBlockEntityFileType()"
    (updateComment)="updateComment($event)"
    (attachFile)="attachFile($event)"
  ></div>
</app-base-modal>
